/**
 * Phần thuần của hộp thoại "Bắt đầu cuộc trò chuyện mới" (có test riêng).
 */
import { i18n } from '@/lib/i18n'
import type { ChannelAccount } from '@/hooks/use-integrations'
import { PLATFORM } from '@/hooks/use-integrations'
import { CHANNELS, type ChannelDef } from '@/pages/integrations/channel-catalog'

export interface ChannelOption {
  def: ChannelDef
  /** Tài khoản của kênh đang chạy được (đã kết nối, không bị tắt). */
  accounts: ChannelAccount[]
  /** Mở hội thoại bằng SĐT được không — hiện chỉ Zalo cá nhân. */
  phoneSupported: boolean
}

/** Hàm (không phải hằng) để theo ngôn ngữ đang chọn. */
export const phoneOnlyHint = () => i18n.t('convContact:newConvLib.phoneOnlyHint')

/** Kênh mở hội thoại bằng số điện thoại được (khớp backend phoneStartSupport). */
export function supportsPhoneStart(def: ChannelDef): boolean {
  return !!def.platforms?.includes(PLATFORM.ZALO_USER)
}

export function isUsableAccount(a: ChannelAccount): boolean {
  return !a.isDisabled && a.liveStatus === 'connected'
}

/**
 * Các kênh tổ chức THẬT SỰ có tài khoản (bỏ kênh beta/chưa có backend).
 * Kênh hỗ trợ SĐT xếp trước. Kênh có tài khoản nhưng đều mất kết nối vẫn liệt
 * kê (accounts rỗng) để người dùng hiểu vì sao không chọn được.
 */
export function buildChannelOptions(all: ChannelAccount[]): ChannelOption[] {
  const out: ChannelOption[] = []
  for (const def of CHANNELS) {
    if (def.beta || !def.platforms?.length) continue
    const mine = all.filter((a) => def.platforms!.includes(a.platform))
    if (mine.length === 0) continue
    out.push({ def, accounts: mine.filter(isUsableAccount), phoneSupported: supportsPhoneStart(def) })
  }
  return out.sort((a, b) => Number(b.phoneSupported) - Number(a.phoneSupported))
}

/** Kiểm nhanh phía client (backend chuẩn hoá & kiểm lại): 9–15 chữ số, cho phép +, khoảng trắng, -, ., (). */
export function isPlausiblePhone(raw: string): boolean {
  const t = raw.trim()
  if (!t || !/^[+\d\s().-]+$/.test(t)) return false
  const digits = t.replace(/\D/g, '')
  return digits.length >= 9 && digits.length <= 15
}
